// Charts in tabs need to be reinitialized when the tab is activated so they draw correctly
$(document).on('turbo:load', function(){
  $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
    var $newTab = $(e.target);
    $($newTab.attr('href')).find('.js-chart').each(function() {
      Chartkick.charts[$(this).attr('id')].redraw();
    });
  });
});
